import React from "react";

export type CardBodyProps = {
  children: React.ReactNode;
  className?: string;
  showGradient?: boolean | false;
};

export function CardBody({
  children,
  className = "",
  showGradient,
}: CardBodyProps) {
  return (
    <div className={`${className} mt-5`}>
      {children}
      {showGradient && (
        <div>
          <div
            className="absolute right-0 top-0 pointer-events-none"
            style={{
              width: "127px",
              height: "127px",
              backgroundColor: "rgba(72, 74, 74, 0.9)", // #484A4A at 70%
              borderRadius: "50%",
              filter: "blur(64px)",
            }}
          ></div>
          <div
            className="absolute left-0 bottom-0 w-64 h-24 pointer-events-none rounded-bl-xl"
            style={{
              width: "127px",
              height: "127px",
              backgroundColor: "rgba(72, 74, 74, 0.9)", // #484A4A at 70%
              borderRadius: "50%",
              filter: "blur(64px)",
            }}
          ></div>
          <div
            className="absolute right-0 bottom-0 w-64 h-24 pointer-events-none rounded-br-xl"
            style={{
              width: "127px",
              height: "127px",
              backgroundColor: "rgba(72, 74, 74, 0.9)", // #484A4A at 70%
              borderRadius: "50%",
              filter: "blur(64px)",
            }}
          ></div>
        </div>
      )}
    </div>
  );
}
